import React from 'react';

import { List, ListItem, ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
    root : { justifyContent : 'flex-start', padding : '0' },
    ScrollableContent : { 
        gridArea : 'uploadFiles',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        maxHeight: '20vh',
    },
    text : {
        justifyContent : 'flex-start', padding : '0',
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '20px !important',
        textAlign : 'center',
        fontWeight : '400 !important',
    },
    mobText : {
        justifyContent : 'flex-start', 
        padding : '0',
        overflowX : 'hidden',
        textAlign : 'center',
        whiteSpace : 'nowrap',
        fontSize : '15px !important',
        fontWeight : '400 !important',
    },
    listItem : {
        borderRadius : '5px',
        backgroundColor : '#1c1c1c',
        color : 'white',
        '&:hover' : {
            backgroundColor : '#1c1c1c',
            color: 'white',
            borderColor: '#343434',
            border : '1px solid',
        }
    }
}))

const AddedFilesDisplay = function AddedFilesDisplay({view,files}){

    const classes = useStyles();

    var renderFileNames = () => {
        return Array.from(files).map((file,idx)=>{
            if(view === 'mobile'){
                return(
                    <ListItem classes={{ root : classes.listItem }}  key={idx+file.name} >
                        <ListItemText classes={{ primary : classes.mobText }} primary={ ( file.name.length ) > 30 ? (idx+1) + '. ' + file.name.slice(0,25) + '....' + file.name.slice(file.name.length-5,) : (idx+1) + '. ' + file.name }  />
                    </ListItem>
                )
            } else {
                return(
                    <ListItem classes={{ root : classes.listItem }} key={idx+file.name} >
                        <ListItemText classes={{ primary : classes.text }} primary={ ( file.name.length ) > 60 ? (idx+1) + '. ' + file.name.slice(0,55) + '....' + file.name.slice(file.name.length-5,) : (idx+1) + '. ' + file.name }  />
                    </ListItem>
                )
            }
        })

    }

    return(
        <List classes={{ root : classes.ScrollableContent }} >
            {renderFileNames()}
        </List>
    )

}

export default AddedFilesDisplay;